import { CommonCallout } from 'components/common/callouts';
import { MachineContext } from 'contexts/machine.context';
import { BuildPriority } from 'lib_ts/enums/pitches.enums';
import { useContext } from 'react';

const TESTING = false;

export const BuildPriorityCallout = (props: { priority: BuildPriority }) => {
  const { activeModel } = useContext(MachineContext);

  if (!activeModel) {
    return null;
  }

  switch (props.priority) {
    case BuildPriority.Breaks: {
      if (activeModel.supports_breaks && !TESTING) {
        return null;
      }

      return <CommonCallout text="pu.unsupported-breaks-msg" />;
    }

    case BuildPriority.Spins:
    case BuildPriority.Default: {
      if (activeModel.supports_spins && !TESTING) {
        return null;
      }

      return <CommonCallout text="pu.unsupported-spins-msg" />;
    }

    default: {
      return null;
    }
  }
};
